
// 防抖
export function debounce (func, delay) {
  let timeout
  return function () {
    const context = this
    const args = arguments
    clearTimeout(timeout)
    timeout = setTimeout(function () {
      func.apply(context, args)
    }, delay)
  }
}
// 深度拷贝，返回新对象或数组
export function deepCopy (source) {
  var result;
  (source instanceof Array) ? (result = []) : (typeof (source) === 'object') ? (source === null ? (result = '') : (result = {})) : (result = source)
  for (var key in source) {
    result[key] = (typeof source[key] === 'object') ? deepCopy(source[key]) : source[key]
  }
  return result
}
// 流程添加节点时，获取坐标
export function getFlowXYPosition (event, { x, y }) {
  var dom = document.getElementById('dwArea')// 获取容器dom
  var centerDomOffset = dom.getBoundingClientRect()// 获取容器的相对偏移
  var ew = 180// 被拖拽的节点的宽度
  var eh = 38// 被拖拽的节点的高度
  var cdl = centerDomOffset.left// 画布左偏移
  var cdt = centerDomOffset.top// 画布上偏移
  var cx = event.clientX// 鼠标X轴偏移
  var cy = event.clientY// 鼠标Y轴偏移
  var sl = dom.scrollLeft// 容器滚动左边偏移距离
  var st = dom.scrollTop// 容器滚动上部偏移距离
  var sw = dom.scrollWidth// 容器滚动宽度
  var sh = dom.scrollHeight// 容器滚动高度
  var _left = cx - cdl + sl - x
  var _top = cy - cdt + st - y
  return {
    left: _left < 0 ? 0 : (_left > sw - ew ? sw - ew : _left), // 节点拖动左右边界值检测
    top: _top < 0 ? 0 : (_top > sh - eh ? sh - eh : _top)// 节点拖动上下边界值检测
  }
}

/**
 * 将base64的图片数据转为文件格式
 * @param imgData
 */
export function imgDataToFile (imgData) {
  var arr = imgData.split(',')
  var mime = arr[0].match(/:(.*?);/)[1]
  var bstr = atob(arr[1])
  var n = bstr.length
  var u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], 'img.png', { type: mime })
}

export function downloadFile (url, name) {
  const a = document.createElement('a')
  a.setAttribute('href', url)
  a.setAttribute('download', name)
  a.setAttribute('target', '_blank')
  const clickEvent = document.createEvent('MouseEvents')
  clickEvent.initEvent('click', true, true)
  a.dispatchEvent(clickEvent)
}
/**
 * 将json 转换为 string
 * @param {*} data
 * @returns
 */
export function stringify (data) {
  if (data === null) return 'None'
  if (data instanceof Array) {
    const s = data.map(item => {
      return stringify(item)
    })
    return `[${s}]`
  }
  if (data instanceof Object) {
    const keys = Object.keys(data)
    const s = keys.map(key => {
      return `"${key}": ${stringify(data[key])}`
    })
    return `{${s}}`
  }
  const type = typeof (data)
  if (type === 'number' || type === 'boolean') return data
  return `"${data}"`
}
